import { type ReactNode } from "react";
import { styled, type SxProps, type Theme } from "~/common/mui";

interface LabelBoxProps {
  className?: string;
  variant?: "active" | "inactive" | "darkGrey";
  children?: ReactNode;
  sx?: SxProps<Theme>;
}

const StyledLabel = styled("label", {
  shouldForwardProp: (prop) => prop !== "variant",
})<{ variant: LabelBoxProps["variant"] }>(({ theme, variant }) => ({
  padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
  borderRadius: theme.shape.borderRadius,
  fontWeight: "bold",
  ...theme.typography.labelLarge,
  color: theme.palette.text.primary,
  // Variant styles
  ...(variant === "active" && {
    backgroundColor: theme.palette.salesCampaign.main,
    color: theme.palette.salesCampaign.contrastText,
  }),
  ...(variant === "inactive" && {
    backgroundColor: theme.palette.surface.main,
    border: `1px solid ${theme.palette.divider}`,
    padding: "3px 7px", // UX/UI is cannot comprehend that border is separate from padding
  }),
  ...(variant === "darkGrey" && {
    backgroundColor: theme.palette.text.primary,
    color: theme.palette.common.white,
  }),
}));

/**
 * @deprecated use Chip instead
 */
const LabelBox = ({ variant = "active", ...rest }: LabelBoxProps) => {
  return <StyledLabel variant={variant} {...rest} />;
};

export default LabelBox;
